import React from 'react'
import styled from 'styled-components'
import { formatTokenAmount } from '../utils/math-utils'
import { tokens } from '../constants/tokens'
import openLink from '../assets/open.svg'
import { getEtherscanLink } from '../utils/web3-utils'

const TokenAmount = ({ tokenAmount }) => {
  const tokenImg = tokens.find(
    element => element?.symbol === tokenAmount.token?.symbol
  )

  return (
    <Container>
      <span>
        {formatTokenAmount(tokenAmount.amount, tokenAmount.token.decimals, {
          digits: 4,
        })}
      </span>
      <span>{tokenImg && <img src={tokenImg.logoURI} alt="Token" />}</span>
      <span>{tokenAmount.token.symbol}</span>
      {tokenAmount.token.chainId && <a
        href={getEtherscanLink(tokenAmount.token.chainId, tokenAmount.token.id, 'address')}
        target="_blank"
        rel="noreferrer"
      >
        <ImgSm src={openLink} />
      </a>}
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  gap: 7px;
  span {
    margin-right: 5px;
  }
 img {
      height: 20px;
      object-fit: scale-down;
      margin: 0px 0 -4px 4px;
`

const ImgSm = styled.img`
  height: 15px !important;
  width: 15px !important;
  padding: 0px !important;
  margin: 0px 5px;
  margin-top: 1px;
`

export default TokenAmount
